import type { ConfirmationMailIntent } from "../actions/confirmationMail"

type BuildConfirmationMailIntentInput = {
  action: "skip" | "send"
  eligibleEventIds: string[]
}

export function buildConfirmationMailIntent(input: {
  action: "skip"
  eligibleEventIds: string[]
}): Extract<ConfirmationMailIntent, { kind: "skip" }>
export function buildConfirmationMailIntent(input: {
  action: "send"
  eligibleEventIds: string[]
}): Extract<ConfirmationMailIntent, { kind: "send" | "blocked" }>
export function buildConfirmationMailIntent({
  action,
  eligibleEventIds,
}: BuildConfirmationMailIntentInput): ConfirmationMailIntent {
  if (action === "skip") {
    return {
      kind: "skip",
      label: "Ohne Mail weiter",
      disabled: false,
      disabledReason: null,
    }
  }

  if (!eligibleEventIds.length) {
    const message = "Keine bestätigten Termine mit erreichbarem Empfänger vorhanden."

    return {
      kind: "blocked",
      label: "Bestätigungsmails senden",
      disabled: true,
      disabledReason: message,
      message,
    }
  }

  return {
    kind: "send",
    label: "Bestätigungsmails senden",
    disabled: false,
    disabledReason: null,
    eventIds: eligibleEventIds,
  }
}
